export default "__VITE_ASSET__3210b564__"